module.exports = __webpack_public_path__ + "static/media/4K钱江新城.f84c698.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp/4K钱江新城.mp4
// module id = 23/c
// module chunks = 1